import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";
import { useAuth } from "@context/auth";
import { RolesDigitedEnum } from "@context/auth/types";

const CorporateDetailNestedGuard: React.FC = () => {
  const { id } = useParams();
  const { user } = useAuth();
  const { pathname } = useLocation();

  if (!user || !id || user.roles?.includes(RolesDigitedEnum.PRODUCT_OWNER)) {
    return <Outlet />;
  }

  const detailPath = `/corporate/${id}/detail`;
  const isExactDetail =
    pathname === detailPath || pathname === `${detailPath}/`;
  const isCorporateMismatch = id !== String(user.organization_id);

  // Keep existing behavior on /detail root page, but block deep routes under /detail/*.
  if (!isExactDetail && isCorporateMismatch) {
    // Redirect to the forbidden corporate detail root so the existing 403 popup/home flow is reused.
    return <Navigate to={detailPath} replace />;
  }

  return <Outlet />;
};

export default CorporateDetailNestedGuard;
